// Tiny wrappers/utilities used across pages.
import { motion } from "framer-motion";

export function Section({ id, className = "", children, testId }) {
  return (
    <section id={id} data-testid={testId} className={`py-20 md:py-28 ${className}`}>
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">{children}</div>
    </section>
  );
}

export function Eyebrow({ children, className = "", testId }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-2 rounded-full border border-zinc-200 bg-white px-3 py-1 text-xs font-medium uppercase tracking-wider text-zinc-600 ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-zinc-950" />
      {children}
    </span>
  );
}

export function H1({ children, className = "" }) {
  return <h1 className={`font-poppins text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter text-zinc-950 ${className}`}>{children}</h1>;
}
export function H2({ children, className = "" }) {
  return <h2 className={`font-poppins text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-zinc-950 ${className}`}>{children}</h2>;
}
export function Lead({ children, className = "" }) {
  return <p className={`max-w-2xl text-base sm:text-lg leading-relaxed text-zinc-600 ${className}`}>{children}</p>;
}

export function FadeIn({ children, delay = 0, y = 18, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
